import { render, staticRenderFns } from "./OrderStoreRequest.vue?vue&type=template&id=21a5a96e"
import script from "./OrderStoreRequest.vue?vue&type=script&lang=js"
export * from "./OrderStoreRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports